export default __webpack_public_path__ + "static/media/haya_karima_logo.b9e87799.jpg";